import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './cookie-bot.component.scss';
var CookieBot = /** @class */ (function (_super) {
    tslib_1.__extends(CookieBot, _super);
    function CookieBot(element) {
        return _super.call(this, element) || this;
    }
    CookieBot.prototype.init = function () {
    };
    CookieBot.prototype.bindEvents = function () {
    };
    return CookieBot;
}(Base));
export { CookieBot };



//////////////////
// WEBPACK FOOTER
// ./components/cookie-bot/cookie-bot.component.ts
// module id = 584
// module chunks = 0